import Image from 'next/image';
import { ROUTES } from '@/constants/routes/default';
import { getFullYear } from '@/helpers/date';
import Link from 'next/link';
import { cn } from '@/helpers/common';

const desktopLinkCn =
  'second-font tracking-wider text-sm font-semibold text-jc-botticelli py-2 px-3 no-underline default-transition hover:text-jc-my-sin max-md:px-0 max-md:py-1.5 max-md:text-xs';

const FooterJC = ({ isAuthorized }: { isAuthorized: boolean }) => {
  return (
    <footer className="flex md:px-10 max-md:px-4 md:py-8 max-md:py-6 min-h-21 bg-jc-firefly">
      <div className="max-w-280 w-full h-full flex justify-between items-center m-auto flex-wrap gap-4 max-md:flex-col max-md:items-start max-md:gap-5">
        <div className="max-md:w-full">
          <Link href={ROUTES.home} aria-label="Johnson Jobs home">
            <Image
              className="max-[400px]:w-21.5 min-[400px]:w-43 max-[400px]:h-2 min-[400px]:h-4"
              width="172"
              height="16"
              alt="Johnson Jobs"
              src="https://assets.johnsonjobs.com/johnsonjobs/jc-logo.png"
              unoptimized
              priority
            />
          </Link>
          <p className="mt-3 text-xs leading-5 text-jc-gray-chateau max-w-[320px] max-md:max-w-full">
            15001 Kercheval Ave, Grosse Pointe Park, Michigan 48230 © Johnson Jobs {getFullYear()},
            All rights reserved
          </p>
        </div>
        <nav aria-label="Footer" className="flex flex-col gap-1 max-md:w-full">
          <div className="flex gap-x-5 gap-y-1 flex-wrap max-md:flex-col">
            <Link className={desktopLinkCn} href={ROUTES.home}>
              HOME
            </Link>
            <Link className={desktopLinkCn} href={ROUTES.jobs}>
              SEARCH JOBS
            </Link>
            {isAuthorized ? (
              <Link className={desktopLinkCn} href={ROUTES.profile}>
                WORK PREFERENCES
              </Link>
            ) : (
              <Link className={desktopLinkCn} href={ROUTES.signup}>
                CREATE PROFILE
              </Link>
            )}
            <Link className={desktopLinkCn} href={ROUTES.partners}>
              PARTNERSHIP
            </Link>
          </div>
          <div className="flex max-md:justify-start md:justify-end gap-x-5 gap-y-1 flex-wrap">
            <Link className={cn(desktopLinkCn, 'text-xs!')} href={ROUTES.termsOfUse}>
              Terms of Use
            </Link>
            <Link className={cn(desktopLinkCn, 'text-xs!')} href={ROUTES.privacyPolicy}>
              Privacy Policy
            </Link>
          </div>
        </nav>
      </div>
    </footer>
  );
};

export default FooterJC;
